import React from 'react';
import { toast } from 'react-toastify';
import './PriceInfoField.css';
import UnitSelector from '../../UnitSelector/UnitSelector';
class DensityInfoField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      density: 1.0,
      currentUnits: 'kg / L',
    }
  }
  onSaveChanges() {
    let density = this.state.density + this.state.currentUnits;
    this.props.onClickOut('Density', density);
  }

  componentDidMount() {
    if (this.props.content !== null) {
      this.setState({ string: this.props.content })
    }
  }
  handleDblClick = (e) => {
    let immutable;
    let ingredient = this.props.ingredient;
    for (let i = 0; i < ingredient.used_in_recipes.length; i++) {
      if (ingredient.used_in_recipes[i].immutable) {
        immutable = true;
      }
    }
    if (immutable) {
      toast.error('This ingredient is used in locked recipes. Version this ingredient before editing its density.')
      return
    }
    if (this.node.contains(e.target)) {
      this.setState({
        editing: true
      })
    }
    else if (this.state.editing !== false) {
      this.onSaveChanges();
      this.setState({ editing: false })
    };
  }
  changeUnits = (e) => {
    this.setState({ currentUnits: e.target.value });
  }
  componentWillMount() {
    document.addEventListener('dblclick', this.handleDblClick, false);
  }
  componentWillUnmount() {
    document.removeEventListener('dblclick', this.handleDblClick, false);
  }
  handleEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSaveChanges();

      this.setState({ editing: false })
    }

  }
  onChangePriceInfo = (e) => {
    this.setState({
      density: e.target.value,
    });
  }
  onKeyDown = (e) => {
    if (e.key === 'Escape') {
      this.setState({ editing: false })
    }
  }
  render() {
    let density;
    let ingredient = this.props.ingredient;
    if (!ingredient) {
      return null
    }
    let lockedMessage;
    let immutable;
    for (let i = 0; i < ingredient.used_in_recipes.length; i++) {
      if (ingredient.used_in_recipes[i].immutable) {
        immutable = true;
      }
    }
    if (immutable) {
      lockedMessage = "This ingredient is used in locked recipes. Changing the density will affect those recipes. Version this ingredient or override and change the density anyway."
    }
    return (

      <div className='doc-info-field' ref={node => this.node = node}>
        {this.props.nolabel ? null : <label className='document-label noselect' >
          {this.props.contentType} </label>}

        {this.state.editing ?
          <div>
            <div className="priceInfoInput"><input
              value={this.state.density}
              type='number'
              step='0.01'
              className='document-info-field'
              onChange={this.onChangePriceInfo}
              onKeyPress={this.handleEnter}
              onKeyDown={this.onKeyDown} />
              <div>
                <select className="unitSelector" onChange={this.changeUnits}
                  value={this.state.currentUnits}>
                  <option value="kg / L">kg/L</option>
                  <option value="lb / gal">lb/gal</option>
                </select>
              </div>
            </div>
            <div>{lockedMessage}</div>
          </div>
          :

          <div className='priceInfoContainer'>
            <div className="priceInfoItem">{ingredient.f_density_kg_L}</div>
            <div className="priceInfoItem">{ingredient.f_density_lb_gal}</div>
          </div>
        }
      </div>)

  }
}
export default DensityInfoField;
